/**
 * App全局store(只用于存放全局公共信息)
 */

const app = {
    name: 'app',
    namespaced: true,
    state: {
    },
    actions: {
    },
};

export default app;
